var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCaretDownRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0155 4.76552L6.26552 8.51552C6.23069 8.55039 6.18934 8.57805 6.14381 8.59692C6.09829 8.61579 6.04949 8.6255 6.00021 8.6255C5.95093 8.6255 5.90213 8.61579 5.85661 8.59692C5.81108 8.57805 5.76972 8.55039 5.7349 8.51552L1.9849 4.76552C1.91453 4.69516 1.875 4.59972 1.875 4.50021C1.875 4.4007 1.91453 4.30526 1.9849 4.2349C2.05526 4.16453 2.1507 4.125 2.25021 4.125C2.34972 4.125 2.44516 4.16453 2.51552 4.2349L6.00021 7.72005L9.4849 4.2349C9.51974 4.20005 9.5611 4.17242 9.60662 4.15356C9.65214 4.1347 9.70094 4.125 9.75021 4.125C9.79948 4.125 9.84827 4.1347 9.8938 4.15356C9.93932 4.17242 9.98068 4.20005 10.0155 4.2349C10.0504 4.26974 10.078 4.3111 10.0969 4.35662C10.1157 4.40214 10.1254 4.45094 10.1254 4.50021C10.1254 4.54948 10.1157 4.59827 10.0969 4.64379C10.078 4.68932 10.0504 4.73068 10.0155 4.76552Z",
    fill: "#C7061F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaretDownRed);
export default __webpack_public_path__ + "static/media/CaretDownRed.79df46e0d9820f44a3cc44c4c6fbb1e1.svg";
export { ForwardRef as ReactComponent };